module.exports = __webpack_public_path__ + "img/region-header.e84f031d.jpg";